import { Stack, styled } from '@mui/system';
import { Box, Button, Typography, Avatar } from '@mui/material';

export const PhotoStepContainer = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px 16px',
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  gap: '16px',
});


export const PhotoAndDescriptionContainer = styled(Stack)({
  gap: '32px',
  justifySelf: 'center',
});

export const UploadOptionsContainer = styled(Box)({
  width: '100%',
  background: 'var(--BG-Primary---Dark-Elevated, #1C1C1E)',
  borderRadius: '10px',
});

export const UploadOptionButton = styled(Button)(({ isFirst }) => ({
  height: '52px',
  justifyContent: 'space-between',
  color: '#FFFFFF',
  width: 'inherit',
  padding: '16px',
  borderRadius: '0',
  borderBottom: isFirst ? '1px solid rgba(118, 118, 128, 0.35)' : 'none',
  '&:hover': {
    backgroundColor: 'rgba(118, 118, 128, 0.15)',
    borderBottom: isFirst ? '1px solid rgba(118, 118, 128, 0.35)' : 'none',
  },
}));


export const LooksGoodButton = styled(Button)({
  width: 'inherit',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  backgroundColor: '#444',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: '#555',
  },
});

export const SavePhotoButton = styled(Button)({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  width: 'inherit',
  textTransform: 'none',
  borderRadius: '12px',
  background: "var(--Fills - Tertiary-- - Dark, rgba(118, 118, 128, 0.24))",
  color: '#ffffff',
  fontSize: '17px',
  lineHeight: '22px',
  fontWeight: '400',
  padding: '14px 20px',
  letterSpacing: '-0.4px',
  '&:hover': {
    backgroundColor: 'rgba(118, 118, 128, 0.35)',
    color: '#3692ff',
  },
});

export const ProfilePhoto = styled(Avatar)({
  width: 104,
  height: 104,
  alignSelf: 'center',
  backgroundColor: 'rgba(120, 120, 128, 0.36)',
  color: 'rgba(235, 235, 245, 0.60)',
  img: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
});

export const SkipLink = styled(Typography)({
  color: '#0A84FF',
  textDecoration: 'none',
  cursor: 'pointer',
  fontWeight: '400',
  fontSize: '17px',
  lineHeight: '22px',
  letterSpacing: '-0.4px',

  '&:hover': {
    color: '#ffffff',
  },
});